import { inject, injectable } from 'inversify';
import {
  type UrlQueryParameter,
  type ApiPlatformUrlParameterFactory,
  type GetListUrlParamsFactory,
  PaginationQueryFilter,
  TermQueryFilter,
  type GetListParams,
  CrudDependencyTypes,
} from '@kiplin/web-common/crud';

@injectable()
export class CockpitApiListService {
  constructor(
    @inject(CrudDependencyTypes.ApiPlatformUrlParameterFactory)
    private readonly apiPlatformUrlParameterFactory: ApiPlatformUrlParameterFactory,
    @inject(CrudDependencyTypes.GetListUrlParamsFactory)
    private readonly getListUrlParamsFactory: GetListUrlParamsFactory,
  ) {}

  public buildListQueryParams(params: GetListParams): UrlQueryParameter {
    const { pagination, term, filters, queryFilters } = params;
    const page = pagination.page;
    const itemsPerPage = pagination.itemsPerPage;
    const baseQueryFilters = [
      new PaginationQueryFilter(page, itemsPerPage),
      ...(term ? [new TermQueryFilter(term)] : []),
    ];
    const urlParameters = this.apiPlatformUrlParameterFactory.createQueryParametersFrom([
      ...baseQueryFilters,
      ...(queryFilters ?? []),
    ]);

    return {
      ...this.getListUrlParamsFactory.getParams(term, page, itemsPerPage, filters),
      ...urlParameters,
    };
  }
}
